module.exports = __webpack_public_path__ + "img/ic_qmarker_asset_lbl.87fea8e0.png";